import React from 'react'
import './RandomText.css'

const RandomText = ({paragraph}) => {
    return (
        <p className="paragraph">
            {paragraph}
        </p>
        
    )
};

export default RandomText
